// @intent: Typed project-list API contract for persisted project cards
// @flow: Runtime project rows -> /api/v1/projects -> Dashboard and EditorEmptyState
// @stale: Add status/preview fields when project publishing state becomes persisted

import { z } from 'zod/v4';

export const ProjectOriginSchema = z.enum(['generated', 'sample', 'manual', 'unknown']);
export type ProjectOrigin = z.infer<typeof ProjectOriginSchema>;

export const ProjectDisplayReadinessSchema = z.enum(['ready', 'building', 'failed', 'incomplete', 'sample']);
export type ProjectDisplayReadiness = z.infer<typeof ProjectDisplayReadinessSchema>;

export const ProjectListItemSchema = z.strictObject({
  id: z.uuid(),
  name: z.string().min(1),
  template: z.string().min(1),
  viewport: z.strictObject({
    width: z.number().int().positive(),
    height: z.number().int().positive(),
  }),
  updatedAt: z.iso.datetime(),
  latestCommitId: z.uuid().nullable(),
  origin: ProjectOriginSchema.optional(),
  readiness: ProjectDisplayReadinessSchema.optional(),
  statusLabel: z.string().trim().min(1).optional(),
  generationRunId: z.uuid().optional(),
  failureMessage: z.string().trim().min(1).optional(),
});

export const ProjectListResponseSchema = z.strictObject({
  projects: z.array(ProjectListItemSchema),
});

export type ProjectListItem = z.infer<typeof ProjectListItemSchema>;
export type ProjectListResponse = z.infer<typeof ProjectListResponseSchema>;
